import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UserAddIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 12C17.21 12 19 10.21 19 8S17.21 4 15 4C12.79 4 11 5.79 11 8S12.79 12 15 12ZM15 6C16.1 6 17 6.9 17 8S16.1 10 15 10C13.9 10 13 9.1 13 8S13.9 6 15 6ZM15 14C12.33 14 7 15.34 7 18L7 20L23 20L23 18C23 15.34 17.67 14 15 14ZM9 18C9.22 17.28 12.31 16 15 16C17.7 16 20.8 17.29 21 18L9 18ZM6 15L6 12L9 12L9 10L6 10L6 7L4 7L4 10L1 10L1 12L4 12L4 15Z"
      fill="currentColor"
    />
  </svg>
);

UserAddIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UserAddIcon);
